import { endpoints } from '../Constants';
import { authHeader, toQueryStringURL } from '../Helpers';
import handleResponse from './helpers';

const productionPlanAutoGenServices = {
	list,
	save,
	deleteConfig,
	listShiftsForStore,
};

function postOptions(body) {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(body || {}),
	};
}

function list(req = {}) {
	return fetch(
		endpoints.PRODUCTION_PLAN_AUTOGEN_LIST,
		postOptions(req?.data)
	).then(handleResponse);
}

function save(req = {}) {
	return fetch(
		endpoints.PRODUCTION_PLAN_AUTOGEN_SAVE,
		postOptions(req?.data)
	).then(handleResponse);
}

function deleteConfig(req = {}) {
	return fetch(
		endpoints.PRODUCTION_PLAN_AUTOGEN_DELETE,
		postOptions(req?.data)
	).then(handleResponse);
}

function listShiftsForStore(storeId) {
	const url = toQueryStringURL(
		endpoints.SHIFTS_DATA,
		storeId ? {
			storeId,
		} : {}
	);
	return fetch(url, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
	}).then(handleResponse);
}

export default productionPlanAutoGenServices;
